"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const grid_1 = require("../../generic/grid");
const Text_1 = __importDefault(require("../../generic/Text"));
const MokuNotePanel_style_1 = require("./MokuNotePanel.style");
const theme_style_1 = __importDefault(require("../../../theme.style"));
const Layouts_1 = require("../../generic/Layouts");
const images_1 = require("../../../images");
const MokuNotePanel = ({ title, description, visible = true, color, transparent, showClose, onClose, footer, children, noMoku, }) => (react_1.default.createElement(MokuNotePanel_style_1.MokuNotePanelContainer, { color: color, visible: visible, transparent: transparent },
    showClose && react_1.default.createElement(MokuNotePanel_style_1.CloseButton, { src: images_1.close, onClick: onClose }),
    react_1.default.createElement(Text_1.default, { bold: true, size: 13 }, title),
    react_1.default.createElement(Layouts_1.RowSpacer, { height: 4 }),
    react_1.default.createElement(grid_1.Row, null,
        react_1.default.createElement(grid_1.Col, { centerVertical: true, size: 1 },
            react_1.default.createElement(Text_1.default, { size: 13 }, description)),
        react_1.default.createElement(grid_1.Col, { centerVertical: true, size: 0, style: { justifyContent: 'end', paddingLeft: '5%' } }, !noMoku && react_1.default.createElement(MokuNotePanel_style_1.MokuChatCustom, { color: color && theme_style_1.default.colors[color] }))),
    footer && footer,
    children && react_1.default.createElement(grid_1.Row, { padTop: "16px" }, children)));
exports.default = MokuNotePanel;
